import {Component, Injector, OnInit} from '@angular/core';
import {BaseComponent} from '../../../base.component';
import {MatDialogRef} from '@angular/material/dialog';
import {DataResponse} from '../../../../network/service/data.response';
import {SnackBarUtil} from '../../../../util/snack.bar.util';
import {AddOrUpdateAdditiveOptions} from './options/add-or-update-additive.options';

@Component({
  selector: 'app-add-or-update-additive',
  standalone: false,
  templateUrl: './add-or-update-additive.component.html',
  styleUrl: './add-or-update-additive.component.scss'
})
export class AddOrUpdateAdditiveComponent extends BaseComponent implements OnInit {
  addOrUpdateAdditiveOptions = new AddOrUpdateAdditiveOptions();
  title?: any;
  maxChoice?: any;
  type?: any;
  option = [
    {
      Value: 'MANDATORY',
      Title: 'MANDATORY'
    }, {
      Value: 'OPTIONAL',
      Title: 'OPTIONAL'
    }
  ];
  selectedType?: any;
  isActive?: any;

  constructor(injector: Injector, private readonly matDialogRef: MatDialogRef<AddOrUpdateAdditiveComponent>) {
    super(injector);
  }

  override ngOnInit() {
    super.ngOnInit();
    this.title = this.addOrUpdateAdditiveOptions.additive.Title;
    const type = this.addOrUpdateAdditiveOptions.additive.Type;
    this.selectedType = this.option.find(o => o.Value === type);
    this.type = type;
    this.isActive = this.addOrUpdateAdditiveOptions.additive.IsActive;
    this.maxChoice = this.addOrUpdateAdditiveOptions.additive.MaxChoice;
  }

  override loadOnline() {
    super.loadOnline();
  }

  noAction() {
    this.matDialogRef.close();
  }

  onSubmitClicked() {
    (this.addOrUpdateAdditiveOptions.additive.AdditiveId !== undefined ? this.serviceApi.updateAdditives(this.addOrUpdateAdditiveOptions.additive.AdditiveId, {
      Title: this.title,
      Type: this.type,
      MaxChoice: this.maxChoice,
      IsActive: this.isActive
    }) : this.serviceApi.createAdditives({
      Title: this.title,
      Type: this.type,
      MaxChoice: this.maxChoice,
      IsActive: this.isActive
    })).subscribe((res: DataResponse<any>) => {
      if (res.success) {
        this.addOrUpdateAdditiveOptions.onInsertOrUpdateFinished();
        this.noAction();
      } else {
        SnackBarUtil.makeMessage(this, this.translateService.instant(res.message!), res.success, res.data);
      }
    });
  }
}
